import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { LoadingPane } from '@social-solutions/ssg-forms';
import IndividualMeetingComponent from '../individualMeeting/individualMeeting.component';
import ScheduleHeaderComponent from '../scheduleHeader/scheduleHeader.component';
import * as authActions from '../../auth/auth.actions';
import * as myScheduleActions from './mySchedule.actions';
import { convertGuidToInt } from '../../common/number-utils';
import './mySchedule.scss';

/** displays a survey form for a participant to fill out, only valid to fill out once */
class MyScheduleComponent extends Component {

  componentDidMount() {
    this.refreshAppointments();
  }

  refreshAppointments(newDate) {
    const { auth, appointments: { date }, myScheduleActions } = this.props;
    const { currentSession } = auth || {};
    const { user } = currentSession || {};
    const { externalId: participantIdHex } = user || {};
    const userId = convertGuidToInt(participantIdHex);

    let d = newDate !== undefined ? newDate : date;
    myScheduleActions.fetchAppointments(userId, moment(d).startOf('day').toDate(), moment(d).endOf('day').toDate());
  }

  render() {
    const { redirectTo, appointments: { appointments, date, fetch }, myScheduleActions } = this.props;

    const RightArrow = () => {
      return (

        <svg width="1em" height="1em" viewBox="0 0 10 16">
          <path
            d="M6.64 8.003L.272 2.018a.842.842 0 010-1.238L.83.256A.954.954 0 011.488 0c.25 0 .483.09.659.256l7.581 7.126a.842.842 0 010 1.243l-7.574 7.12a.954.954 0 01-.659.255.955.955 0 01-.658-.256l-.558-.524a.84.84 0 010-1.238l6.36-5.979z"
            fillRule="nonzero"
          />
        </svg>
      );
    };

    const LeftArrow = () => {
      return (
        <svg width="1em" height="1em" viewBox="0 0 10 16">
          <path
            d="M 3.36,8.003 9.728,2.018 a -0.842,0.842 0 0 0 0,-1.238 L 9.17,0.256 A -0.954,0.954 0 0 0 8.512,0 C 8.262,0 8.029,0.09 7.853,0.256 L 0.272,7.382 a -0.842,0.842 0 0 0 0,1.243 l 7.574,7.12 A -0.954,0.954 0 0 0 8.505,16 -0.955,0.955 0 0 0 9.163,15.744 L 9.721,15.22 a -0.84,0.84 0 0 0 0,-1.238 L 3.361,8.003 Z"
            fillRule="nonzero"
          />
        </svg>
      );
    };

    const isToday = moment(date).isSame(new Date(), 'day');

    const onStepBack = () => {
      const newDate = moment(date).subtract(1, 'day');
      myScheduleActions.changeDate(newDate);
      this.refreshAppointments(newDate);
    }
    const onStepForward = () => {
      const newDate = moment(date).add(1, 'day');
      myScheduleActions.changeDate(newDate);
      this.refreshAppointments(newDate);
    }
    const openAppointmentDetails = (id) => redirectTo(`/appointments/details/${id}`);

    return (
      <div>
        <ScheduleHeaderComponent location={'/'} />
        <div className="my-schedule-widget">
          <h3>My Scheduled Appointments</h3>
          <div className="calendar-header">
            <button onClick={() => onStepBack()}><LeftArrow /></button>
            <span className="date-info">
              {isToday ? (<div className="today-label">TODAY</div>) : <div></div>}
              <div className="date-label">{moment(date).format('LL')}</div>
            </span>
            <button onClick={() => onStepForward()}><RightArrow /></button>
          </div>
          <div className="meeting-holder">
            <LoadingPane loadingMessage="Loading Appointments" loadingState={{ isLoading: fetch.isFetching, data: fetch.data, error: fetch.error }}>
              {!fetch.isFetching ? (
                appointments.value && appointments.value.length ? appointments.value
                .sort((a, b) => moment(a.startTime).diff(moment(b.startTime)))
                .map((e) => (
                  <IndividualMeetingComponent
                    key={e.id}
                    title={e.title}
                    startTime={e.startTime}
                    endTime={e.endTime}
                    id={e.id}
                    onClick={() => openAppointmentDetails(e.id)}
                  />
                )) : <div className="no-events">No Appointments scheduled for this date.</div>
              ) : null}
            </LoadingPane>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth, appointments }) => {
  return {
    auth,
    appointments,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    redirectTo: bindActionCreators(push, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
    myScheduleActions: bindActionCreators(myScheduleActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyScheduleComponent);



// WEBPACK FOOTER //
// src/scheduler/mySchedule/mySchedule.component.js